import { useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { userStateAtom } from "../atoms/userStateAtom";
import { useEffect, useState } from "react";
import MakeRoom from "../components/MakeRoom";
import { SocketProps } from "../types/interface";
import { isMakeRoomShowAtom } from "../atoms/isMakeRoomShowAtom";
import { gametypeSaveAtom } from "../atoms/gametypeSaveAtom";

const Home: React.FC<SocketProps> = ({ socket }) => {
  const user = useRecoilValue(userStateAtom);
  const userId = user.userData.userIdphp;
  const navigate = useNavigate();
  const [roomName, setRoomName] = useState("");
  const [rooms, setRooms] = useState<any[]>([]);
  const [setMakeRoom, setMakeRoomShow] = useRecoilState(isMakeRoomShowAtom);
  const [userLoginState, setUserLoginState] = useRecoilState(userStateAtom);
  const userGradeNumber = userLoginState.userData.grade;
  //방 타입만 정하는 아톰을 설정
  const [gameTypeAtom, setGameTypeAtom] = useRecoilState(gametypeSaveAtom);
  console.log(rooms);

  const getRooms = (rooms: any) => {
    setRooms(rooms);
  };

  const handleRoomClick = (room: any) => {
    console.log("룸클릭 실행됨!!!!!!");
    if (room.users.find((user: any) => user.id === userId)) {
      alert("이미 접속하였습니다.");
      return;
    }
    if (room.occupants === room.config.maxUser) {
      alert("방이 꽉 찼습니다.");
      return;
    }
    if (room.isStart === true) {
      alert("학습이 진행중입니다.");
      return;
    }
    if (room.pw === "")
      navigate("/fun_learning/room", {
        state: { id: userId, roomName: room.name },
      });
    else {
      const res = window.prompt("방 비밀번호 입력");
      const callBack = (result: any) => {
        if (result) {
          navigate("/fun_learning/room", {
            state: { id: userId, roomName: room.name },
          });
          setGameTypeAtom(room.config.gameType);
          console.log("room 에 대한 정보", room);
        } else alert("비밀번호가 틀렸습니다.");
      };
      console.log(room.name, res);
      socket.emit("check_pw", room.name, res, callBack);
    }
  };

  useEffect(() => {
    socket.on("room_list", getRooms);
    socket.emit("get-rooms");

    return () => {
      socket.off("room_list", getRooms);
    };
  }, []);

  const showCreateRoom = () => {
    setMakeRoomShow(true);
  };
  const onEnterCodeNavigate = () => {
    navigate("/fun_learning/entercode");
  };

  return (
    <div className="h-lvh dark:bg-gray-700 bg-gray-200 pt-12 pb-5 ">
      <div className="dark:text-slate-200 font-bold text-slate-800 text-xl text-center max-w-sm mx-auto mt-5 mb-7">
        <div>협력학습 교실을 만드세요!</div>
        <button
          onClick={showCreateRoom}
          className="mt-3 inline-block w-auto text-center min-w-[200px] px-6 py-4 text-white transition-all rounded-md shadow-xl sm:w-auto bg-gradient-to-r from-blue-600 to-blue-500 hover:bg-gradient-to-b dark:shadow-blue-900 shadow-blue-200 hover:shadow-2xl hover:shadow-blue-400 hover:-tranneutral-y-px "
        >
          교실 만들기
        </button>
      </div>

      <div className="dark:text-slate-200 font-bold text-slate-800 text-2xl text-center max-w-sm mx-auto mt-5 mb-3">
        협력학습에 참여하세요!
      </div>

      <table className="mx-auto bg-white dark:bg-gray-900 rounded-lg shadow-lg mb-10">
        <thead className="bg-gray-50 dark:bg-gray-700">
          <tr>
            <th
              scope="col"
              className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
            >
              User id
            </th>
            <th
              scope="col"
              className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
            >
              교실
            </th>
            <th
              scope="col"
              className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
            >
              종류
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200 dark:bg-gray-900">
          {rooms.map((room: any) => {
            const maxUserNum = +room.config.maxUser;
            if (maxUserNum >= 1) {
              return (
                <tr key={room.name} onClick={() => handleRoomClick(room)}>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                      <div className="text-sm font-medium text-gray-900 dark:text-gray-200">
                        {room.config.owner}
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {/* <div className="text-sm text-gray-900 dark:text-gray-200">
                      {room.name}
                    </div> */}
                    <div className="text-sm text-gray-900 dark:text-gray-200">
                      {room.isStart ? (
                        <div className="text-slate-500">학습중</div>
                      ) : (
                        `${room.name}`
                      )}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800 dark:bg-blue-700 dark:text-blue-200">
                      {room.users.length} / {room.config.maxUser}
                    </span>
                  </td>
                </tr>
              );
            }
          })}
        </tbody>
      </table>

      {/* <div className="dark:text-slate-200 font-bold text-slate-800 text-xl text-center max-w-sm mx-auto mt-5">
        <div>코드를 입력해서 입장하세요</div>
        <button
          onClick={onEnterCodeNavigate}
          className="mt-3 inline-block w-auto text-center min-w-[200px] px-6 py-4 text-white transition-all rounded-md shadow-xl sm:w-auto bg-gradient-to-r from-pink-600 to-pink-500 hover:bg-gradient-to-b dark:shadow-pink-900 shadow-pink-200 hover:shadow-2xl hover:shadow-pink-400 hover:-tranneutral-y-px "
        >
          Enter Code
        </button>
      </div> */}
      {setMakeRoom && (
        <div className=" fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="">
            <MakeRoom socket={socket} />
          </div>
        </div>
      )}
    </div>
  );
};
export default Home;
